import { graphql } from "gql";

const INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_LIST_QUERY = graphql(`
  query InternalAdminUserAttributeCategoryList(
    $organizationId: ID!
    $input: InternalAdminUserAttributeCategoryListInput!
  ) {
    internalAdminUserAttributeCategoryList(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminUserAttributeCategory
    }
  }
`);

export default INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_LIST_QUERY;
